import React, { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { loadingState } from "src/atom/LoadingState";
import { alertMessageState } from "src/atom/LoadingState";
import "../Preview/preview_style.css";
import { fetchScorecardData } from "src/services/Registration/RegisterationService";
import { fetchPreviewQuestions } from "src/services/GenericPreview/PreviewService";
import callApi from "src/services/Common/api";
import { useLocation } from "react-router-dom";
import ScrutinyPreview from "./ScrutinyPreviewPage";

export default function ViewApplication() {
  const enableLoader = useSetRecoilState(loadingState);
  const setAlertMessage = useSetRecoilState(alertMessageState);
  const [personalData, setPersonalData] = useState({});
  const [masterQuestions, setMasterQuestions] = useState({});
  const [formData, setFormData] = useState({});
  const location = useLocation();
  const id = location.state?.id;
  const pageId = location.state?.pageId;
  const candidates = location.state?.candidates;
  const status = location.state?.status;

  useEffect(() => {
    fetchMasterQuestionsApiCall();
    fetchScorecardDataApiCall();
  }, [id]);

  const fetchDataApiCall = async () => {
    var fetchDataMethod = async () => {
      var url = `/v1/api/scrutiny-verification/${id}`;
      const responseData = await callApi(
        url,
        "GET",
        null,
        true,
        setAlertMessage
      );
      if (responseData.success != false) {
        if (responseData.body && Object.keys(responseData.body).length > 0) {
          setFormData(responseData.body);
        }
      }
    };
    fetchDataMethod();
  };

  useEffect(() => {
    if (masterQuestions?.category_details != undefined) {
      fetchDataApiCall();
    }
  }, [masterQuestions]);

  const fetchMasterQuestionsApiCall = async () => {
    var fetchQuestions = async () => {
      enableLoader(true);
      var response = await fetchPreviewQuestions(pageId);
      if (response.success) {
        setMasterQuestions(response.body);

        var initialForm = {};
        for (var i = 0; i < response.body.length; i++) {
          if (response.body[i].type === "S" || response.body[i].type === "ST") {
            initialForm[response.body[i].id] = response.body[i].defaultOptionId;
          } else {
            initialForm[response.body[i].id] = response.body[i].defaultValue;
          }
        }
        setFormData(initialForm);

        enableLoader(false);
      } else {
        enableLoader(false);
        setAlertMessage(response.message);
      }
    };
    enableLoader(false);
    fetchQuestions();
  };

  const fetchScorecardDataApiCall = () => {
    var scorecardDetails = async () => {
      const response = await fetchScorecardData(id);
      enableLoader(false);
      if (response.success) {
        setPersonalData(response.body);
      } else {
        setAlertMessage(response.message);
      }
    };
    scorecardDetails();
  };
  return (
    <>
      <ScrutinyPreview
        pageId={pageId}
        scrutinyId={id}
        personalData={personalData}
        formData={formData}
        masterQuestions={masterQuestions}
        candidates={candidates}
        status={status}
      ></ScrutinyPreview>
    </>
  );
}
